import {
    JSXElementConstructor,
    ReactElement,
    ReactNode,
    cloneElement,
    isValidElement,
    useId,
} from 'react';

import { FormErrorText, VerticalContainer } from '@/components';

type FormControlProps<T extends string | JSXElementConstructor<any>> = {
    children: ReactElement<any, T>;
    label?: string | ReactNode;
    className?: string;
    error?: string;
    spoiler?: string;
    id?: string;
};

export const FormControl = <T extends string | JSXElementConstructor<any>>({
    label,
    children,
    className,
    error,
    spoiler,
    id,
}: FormControlProps<T>) => {
    const generatedId = useId();
    const finalId = id ?? generatedId;
    const enhancedChild = isValidElement(children)
        ? cloneElement(children, { id: finalId, invalid: !!error })
        : children;

    return (
        <VerticalContainer spacing="none" className={className}>
            {label && (
                <label
                    className="form-label flex w-full items-center"
                    htmlFor={finalId}
                >
                    {label}
                </label>
            )}
            {enhancedChild}
            {error && <FormErrorText message={error} />}
            {/* TODO: remove margins after full refactoring*/}
            {spoiler && !error && (
                <p className="m-0 mt-1 text-sm text-(--color-text-primary)">
                    {spoiler}
                </p>
            )}
        </VerticalContainer>
    );
};
